export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";